"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _babelHelperVueJsxMergeProps = _interopRequireDefault(require("@vue/babel-helper-vue-jsx-merge-props"));

var _debounce = _interopRequireDefault(require("throttle-debounce/debounce"));

var _collapseTransition = _interopRequireDefault(require("element-ui/lib/transitions/collapse-transition"));

var _checkbox = _interopRequireDefault(require("element-ui/lib/checkbox"));

var _emitter = _interopRequireDefault(require("element-ui/lib/mixins/emitter"));

var _util = require("./model/util");

var _node = require("./model/node");

// 扩展 引入getChildState方法
var __vue_render__ = function __vue_render__(h) {
  var this$1 = this;

  var _vm = this;

  var _h = _vm.$createElement;
  var _c = h;
  return _vm.node.visible && !_vm.node.data.hidden ? _c('div', {
    ref: "node",
    staticClass: "el-tree-node",
    "class": {
      'is-expanded': _vm.expanded,
      'is-current': _vm.tree.store.currentNode === _vm.node,
      'is-hidden': !_vm.node.visible,
      'is-focusable': !_vm.node.disabled,
      'is-checked': !_vm.node.disabled && _vm.node.checked
    },
    attrs: {
      "role": "treeitem",
      "tabindex": "-1",
      "aria-expanded": _vm.expanded,
      "aria-disabled": _vm.node.disabled,
      "aria-checked": _vm.node.checked,
      "draggable": _vm.tree.draggable
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.handleClick($event);
      },
      "contextmenu": function contextmenu($event) {
        return this$1.handleContextMenu($event);
      },
      "dragstart": function dragstart($event) {
        $event.stopPropagation();
        return _vm.handleDragStart($event);
      },
      "dragover": function dragover($event) {
        $event.stopPropagation();
        return _vm.handleDragOver($event);
      },
      "dragend": function dragend($event) {
        $event.stopPropagation();
        return _vm.handleDragEnd($event);
      },
      "drop": function drop($event) {
        $event.stopPropagation();
        return _vm.handleDrop($event);
      }
    }
  }, [_c('div', {
    staticClass: "el-tree-node__content",
    style: {
      'padding-left': _vm._px2rem((_vm.node.level - 1) * _vm.tree.indent + 'px', 24, []),
      'width': _vm._px2rem('100%', 24, [])
    },
    attrs: {},
    on: {
      "mouseenter": function mouseenter($event) {
        _vm.debounceHandleMouseEnter($event);
      },
      "mouseleave": function mouseleave($event) {
        _vm.debounceHandleMouseLeave($event);
      }
    }
  }, [_c('span', {
    staticClass: "el-tree-node__expand-icon el-icon-caret-right",
    "class": {
      'is-leaf': _vm.node.isLeaf,
      expanded: !_vm.node.isLeaf && _vm.expanded
    },
    attrs: {},
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.handleExpandIconClick($event);
      }
    }
  }), _vm._v(" "), _vm.showCheckbox ? _c('el-checkbox', {
    attrs: {
      "indeterminate": _vm.node.indeterminate,
      "disabled": !!_vm.node.disabled
    },
    on: {
      "change": _vm.handleCheckChange
    },
    nativeOn: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    },
    model: {
      value: _vm.node.checked,
      callback: function callback($v) {
        _vm.$set(_vm.node, "checked", $v);
      },
      expression: "node.checked"
    }
  }) : _vm._e(), _vm._v(" "), _vm.node.loading ? _c('span', {
    staticClass: "el-tree-node__loading-icon el-icon-loading",
    attrs: {}
  }) : _vm._e(), _vm._v(" "), _c('node-content', {
    attrs: {
      "node": _vm.node
    }
  })], 1), _vm._v(" "), _c('el-collapse-transition', [!_vm.renderAfterExpand || _vm.childNodeRendered ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.expanded,
      expression: "expanded"
    }],
    staticClass: "el-tree-node__children",
    attrs: {
      "role": "group",
      "aria-expanded": _vm.expanded
    }
  }, [_vm._l(_vm.node.childNodes, function (child) {
    return [!child.data.hidden ? _c('el-tree-node', {
      key: _vm.getNodeKey(child),
      attrs: {
        "render-content": _vm.renderContent,
        "render-after-expand": _vm.renderAfterExpand,
        "node": child
      },
      on: {
        "node-expand": _vm.handleChildNodeExpand
      }
    }) : _vm._e()];
  })], 2) : _vm._e()])], 1) : _vm._e();
};

var __vue_staticRenderFns__ = [];
var _default2 = {
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__,
  name: 'ElTreeNode',
  componentName: 'ElTreeNode',
  mixins: [_emitter["default"]],
  props: {
    node: {
      "default": function _default() {
        return {};
      }
    },
    props: {},
    renderContent: Function,
    renderAfterExpand: {
      type: Boolean,
      "default": true
    }
  },
  beforeCreate: function beforeCreate() {
    var _this = this;

    this.debounceHandleMouseEnter = (0, _debounce["default"])(50, function (e) {
      _this.tree.$emit('mouseenter-node', e);
    });
    this.debounceHandleMouseLeave = (0, _debounce["default"])(50, function (e) {
      _this.tree.$emit('mouseleave-node', e);
    });
  },
  components: {
    ElCollapseTransition: _collapseTransition["default"],
    ElCheckbox: _checkbox["default"],
    NodeContent: {
      props: {
        node: {
          required: true
        }
      },
      render: function render(h) {
        var _vm = this;

        var parent = this.$parent;
        var tree = parent.tree;
        var node = this.node; //* * 扩展 tooltip */

        var style = {
          overflow: 'hidden',
          'text-overflow': 'ellipsis',
          'word-break': 'break-all'
        };
        var directives = [{
          name: 'tooltip',
          modifiers: {
            overflow: true
          }
        }]; //* ************ */

        var data = node.data,
            store = node.store;
        return parent.renderContent ? parent.renderContent.call(parent._renderProxy, h, {
          _self: tree.$vnode.context,
          node: node,
          data: data,
          store: store
        }) : tree.$scopedSlots["default"] ? tree.$scopedSlots["default"]({
          node: node,
          data: data
        }) : // 扩展 tooltip
        h("span", (0, _babelHelperVueJsxMergeProps["default"])([{
          "class": "el-tree-node__label"
        }, {
          directives: directives
        }, {}, {
          style: _vm._px2rem(style, 24, [])
        }]), [node.label]);
      }
    }
  },
  data: function data() {
    return {
      tree: null,
      expanded: false,
      childNodeRendered: false,
      showCheckbox: false,
      oldChecked: null,
      oldIndeterminate: null
    };
  },
  watch: {
    'node.indeterminate': function nodeIndeterminate(val) {
      this.handleSelectChange(this.node.checked, val);
    },
    'node.checked': function nodeChecked(val) {
      this.handleSelectChange(val, this.node.indeterminate);
    },
    'node.expanded': function nodeExpanded(val) {
      var _this2 = this;

      this.$nextTick(function () {
        return _this2.expanded = val;
      });

      if (val) {
        this.childNodeRendered = true;
      }
    }
  },
  methods: {
    getNodeKey: function getNodeKey(node) {
      return (0, _util.getNodeKey)(this.tree.nodeKey, node.data);
    },
    handleSelectChange: function handleSelectChange(checked, indeterminate) {
      // 扩展 修改选择状态是否改变
      if (this.oldChecked !== checked || this.oldIndeterminate !== indeterminate) {
        this.tree.$emit('check-change', this.node.data, checked, indeterminate);
      }

      this.oldChecked = checked;
      this.oldIndeterminate = indeterminate;
    },
    handleClick: function handleClick() {
      var click = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var store = this.tree.store;
      store.setCurrentNode(this.node);
      click && this.tree.$emit('current-change', store.currentNode ? store.currentNode.data : null, store.currentNode);
      this.tree.currentNode = this;

      if (this.tree.expandOnClickNode) {
        this.handleExpandIconClick();
      }

      if (this.tree.checkOnClickNode && !this.node.disabled) {
        this.handleCheckChange(null, {
          target: {
            checked: !this.node.checked
          }
        });
      }

      click && this.tree.$emit('node-click', this.node.data, this.node, this);
    },
    handleContextMenu: function handleContextMenu(event) {
      if (this.tree._events['node-contextmenu'] && this.tree._events['node-contextmenu'].length > 0) {
        event.stopPropagation();
        event.preventDefault();
      }

      this.tree.$emit('node-contextmenu', event, this.node.data, this.node, this);
    },
    handleExpandIconClick: function handleExpandIconClick() {
      if (this.node.isLeaf) return;

      if (this.expanded) {
        this.tree.$emit('node-collapse', this.node.data, this.node, this);
        this.node.collapse();
      } else {
        this.node.expand();
        this.$emit('node-expand', this.node.data, this.node, this);
      }
    },
    handleCheckChange: function handleCheckChange(value, ev) {
      var _this3 = this;

      /** 扩展 当节点的所有未选中的叶子节点都是禁用状态时，将checked置为false */
      var realValue = ev.target.checked;

      if (!this.node.isLeaf && !this.tree.checkStrictly) {
        var leafNodes = this.tree.store.getLeafNodes(this.node);

        var _getChildState = (0, _node.getChildState)(leafNodes),
            allWithoutDisable = _getChildState.allWithoutDisable;

        if (allWithoutDisable && this.node.childNodes.length > 0) realValue = false;
      }

      this.node.setChecked(realValue, !this.tree.checkStrictly);
      /** ********** */

      this.$nextTick(function () {
        var store = _this3.tree.store;

        _this3.tree.$emit('check', _this3.node.data, {
          checkedNodes: store.getCheckedNodes(),
          checkedKeys: store.getCheckedKeys(),
          halfCheckedNodes: store.getHalfCheckedNodes(),
          halfCheckedKeys: store.getHalfCheckedKeys()
        });
      });
    },
    handleChildNodeExpand: function handleChildNodeExpand(nodeData, node, instance) {
      this.broadcast('ElTreeNode', 'tree-node-expand', node);
      this.tree.$emit('node-expand', nodeData, node, instance);
    },
    handleDragStart: function handleDragStart(event) {
      if (!this.tree.draggable) return;
      this.tree.$emit('tree-node-drag-start', event, this);
    },
    handleDragOver: function handleDragOver(event) {
      if (!this.tree.draggable) return;
      this.tree.$emit('tree-node-drag-over', event, this);
      event.preventDefault();
    },
    handleDrop: function handleDrop(event) {
      event.preventDefault();
    },
    handleDragEnd: function handleDragEnd(event) {
      if (!this.tree.draggable) return;
      this.tree.$emit('tree-node-drag-end', event, this);
    }
  },
  created: function created() {
    var _this4 = this;

    var parent = this.$parent;

    if (parent.isTree) {
      this.tree = parent;
    } else {
      this.tree = parent.tree;
    }

    var tree = this.tree;

    if (!tree) {
      console.warn('Can not find node\'s tree.');
    }

    var props = tree.props || {};
    var childrenKey = props.children || 'children';
    this.$watch("node.data.".concat(childrenKey), function () {
      _this4.node.updateChildren();
    });
    this.showCheckbox = tree.showCheckbox;

    if (this.node.expanded) {
      this.expanded = true;
      this.childNodeRendered = true;
    }

    if (this.tree.accordion) {
      this.$on('tree-node-expand', function (node) {
        if (_this4.node !== node) {
          _this4.node.collapse();
        }
      });
    }
  }
};
exports["default"] = _default2;